import { createFileRoute, redirect } from "@tanstack/react-router";
import { hasModule, firstAllowedRoute } from "@/lib/auth";
import { IntakeWork } from "@/features/intake/IntakeWork";

// A row of the invoerbak on the main screen: the mail, and what to do with it (docs/invoerbak.md §4).
export const Route = createFileRoute("/_shell/intake/$id")({
  beforeLoad: ({ context }) => {
    if (context.session.roles.includes("admin") || hasModule(context.session, "order_intake")) return;
    throw redirect({ to: firstAllowedRoute(context.session) });
  },
  component: IntakeRowScreen,
});

function IntakeRowScreen() {
  const { id } = Route.useParams();
  return (
    <div className="wl-page" data-screen-label="Back-office Intake Row">
      <IntakeWork key={id} id={id} />
    </div>
  );
}
